import React from "react";

import {
  FaExternalLinkAlt,
  FaTrophy,
} from "react-icons/fa";

import {
  TOURNAMENT_QUICK_LINKS,
} from "../data/tournamentProductData";

import {
  scrollToTournamentSection,
} from "../utils/tournamentProductUtils";

export default function TournamentQuickNav({
  onDemoClick,
}) {
  return (
    <section className="sticky top-20 z-30 border-b border-slate-200 bg-white/90 shadow-sm backdrop-blur-xl dark:border-white/10 dark:bg-slate-950/90">
      <div className="mx-auto flex max-w-7xl flex-col gap-3 px-4 py-3 sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:px-8">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-orange-500 text-white shadow-lg shadow-orange-500/20">
            <FaTrophy />
          </div>

          <div className="hidden sm:block">
            <p className="text-sm font-bold text-slate-950 dark:text-white">
              MonAppliTournoi
            </p>

            <p className="text-xs text-slate-500 dark:text-slate-400">
              Organisation de tournois interclubs
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2 overflow-x-auto pb-1 lg:pb-0">
          {TOURNAMENT_QUICK_LINKS.map(
            (item) => (
              <button
                key={item.id}
                type="button"
                onClick={() =>
                  scrollToTournamentSection(
                    item.id,
                  )
                }
                className="shrink-0 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 transition hover:border-orange-200 hover:bg-orange-50 hover:text-orange-600 dark:border-white/10 dark:bg-slate-900 dark:text-slate-200 dark:hover:border-orange-400/30 dark:hover:bg-orange-500/10 dark:hover:text-orange-300"
              >
                {item.label}
              </button>
            ),
          )}

          <button
            type="button"
            onClick={onDemoClick}
            className="inline-flex shrink-0 items-center gap-2 rounded-full bg-orange-500 px-4 py-2 text-sm font-bold text-white shadow-sm transition hover:bg-orange-600"
          >
            Voir le site
            <FaExternalLinkAlt className="text-xs" />
          </button>
        </div>
      </div>
    </section>
  );
}